import {useEffect, useMemo, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axios from "axios";
import Loading from "../elements/Loading";
import InlineNotification from "../elements/InlineNotification";

export default function HhChatAuthorizePage() {

    // Авторизация на hh.ru (если есть code в ссылке)
    const [searchParams, setSearchParams] = useSearchParams()
    const [notificationType, setNotificationType] = useState('error')
    const [notificationMessage, setNotificationMessage] = useState('')

    useEffect( () => {
        let error = searchParams.get('error') // access_denied
        let authorization_code = searchParams.get('code')
        let state = searchParams.get('state')
        searchParams.delete('code')
        searchParams.delete('state')
        searchParams.delete('error')
        setSearchParams(searchParams)

        if (error) {
            setNotificationType('error')
            setNotificationMessage(`Ошибка авторизации на hh.ru: ${error}`)
            return
        }
        if (!authorization_code) {
            return
        }
        window.opener.postMessage(authorization_code)
        window.close()
    }, [])

    return <div className={'center-main'}>
        <div className={'main-block'}>
            <Loading isLoading={notificationMessage === ''}/>
            <InlineNotification
                type={notificationType}
                text={notificationMessage}
                hideFlag={notificationMessage.length === 0}
            />
        </div>
    </div>
}